"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PictureIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var PictureIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.76889 14.897L7.94999 12.5696L4.8 16.6H19.2L13.8 9.88311L9.76889 14.897ZM3 5.8C3 4.80579 3.80859 4 4.79155 4H19.2084C20.1977 4 21 4.80085 21 5.8V17.5C21 18.4942 20.1914 19.3 19.2084 19.3H4.79155C3.80226 19.3 3 18.4991 3 17.5L3 5.8ZM7.49999 10.3C8.4942 10.3 9.29999 9.4942 9.29999 8.49999C9.29999 7.50578 8.4942 6.7 7.49999 6.7C6.50578 6.7 5.69999 7.50578 5.69999 8.49999C5.69999 9.4942 6.50578 10.3 7.49999 10.3Z", fill: "currentColor" }))); };
exports.PictureIcon = PictureIcon;
